import serverData from '@/store/serverData'
// import store from '@/store'

import async from 'async'
// import restResource from '@/technical/restResource'

export default function (options, callback) {
  if (options == null) return callback(null)

  serverData.loadingDataStatus.mainCommonData = serverData.loadingDataStatus.types.LOADING

  async.parallel({
    // /////////////////////////////////////////////////////////////////

    appSettings: function (cb) {
      if ((options.all === false) && (options.appSettings === false)) return cb(null, true)
      if ((options.all === true) || (options.appSettings === true)) {} else return cb(null, true)

      serverData.appSettingsReload(function (error) {
        if (error) return cb(error)
        cb(null, true)
      })
    },

    // /////////////////////////////////////////////////////////////////

    places: function (cb) {
      if ((options.all === false) && (options.places === false)) return cb(null, true)
      if ((options.all === true) || (options.places === true)) {} else return cb(null, true)

      serverData.placesReload(function (error) {
        if (error) return cb(error)
        cb(null, true)
      })
    },

    // /////////////////////////////////////////////////////////////////

    events: function (cb) {
      if ((options.all === false) && (options.events === false)) return cb(null, true)
      if ((options.all === true) || (options.events === true)) {} else return cb(null, true)

      serverData.eventsReload(function (error) {
        if (error) return cb(error)
        serverData.eventsReloadMyEvents(function (error) {
          if (error) return cb(error)
          cb(null, true)
        })
      })
    }

    // /////////////////////////////////////////////////////////////////

  }, function (error, results) { // results: {users: true, news: true}
    if (error) serverData.loadingDataStatus.mainCommonData = serverData.loadingDataStatus.types.ERROR
    else serverData.mainCommonDataLoadedSetTrue()

    // try нужен чтобы обработать эксепшен если он случится в callback. все бы хорошо и без try, да тут это место внутри async и вылезает ошибка callback is already called и при этом не ясно по инфе в консоле где эксепшн
    try {
      callback(error)
    } catch (e) {
      console.error('ERROR: mainCommonDataLoader is done, but exception occurs in external callback, which is handling result:')
      console.error(e)
    }
  })
}



// WEBPACK FOOTER //
// ./src/components/mainCommonDataLoader.js